import { useWecomaIntegration } from "../gdpr/use-wecoma-integration";
import { CookieType } from "../gdpr/wecoma-models";
import { type WebStorageJsonType, type WebStorageType } from "./web-storage-type";

const isStorageAvailable: WebStorageJsonType = {
    localStorage: null,
    sessionStorage: null,
};

export const useWebStorageTest = () => {
    /// Checks if the storage is available
    const test = (storageType: WebStorageType) => {
        // see https://gist.github.com/paulirish/5558557
        const storage = window[storageType];
        try {
            if (!(storageType in window && storage !== null)) {
                return false;
            }
            // ios 10 private window, window.sessionStorage exists, but writing ends with exception
            storage.setItem("storage-test", "1");
            storage.removeItem("storage-test");
            return true;
        } catch (error) {
            return false;
        }
    };

    /// check if selected storage is available
    const canUseStorage = (storageType: WebStorageType) => {
        if (isStorageAvailable[storageType] === null) {
            isStorageAvailable[storageType] = test(storageType);
        }

        return isStorageAvailable[storageType];
    };

    /// Checks consets to be able to store value
    const canSetValue = (type: CookieType) => {
        const { cookieTypeConsentedCached } = useWecomaIntegration();
        return cookieTypeConsentedCached(type);
    };

    return {
        canUseStorage,
        canSetValue,
    };
};
